/** Format a product metric value with its unit. */
export function fmtValue(v: number | null | undefined, unit: string | null): string {
  if (v === null || v === undefined) return '—'
  const n = Math.abs(v) >= 1000 ? v.toLocaleString(undefined, { maximumFractionDigits: 0 })
    : v.toLocaleString(undefined, { maximumFractionDigits: 1 })
  if (!unit) return n
  if (unit === '%') return `${n}%`
  if (unit === '$' || unit === '€' || unit === '£') return `${unit}${n}`
  return `${n} ${unit}`
}
